const API_BASE = "/api/v1"

export interface PortraitStatusResponse {
  portrait: {
    status: "none" | "generating" | "ready" | "failed"
    url: string | null
    can_regenerate: boolean
    regeneration_blocked_reason: string | null
    validation_error: string | null
    failure_message: string | null
    generation_count: number
    complimentary_update_used: boolean
  } | null
  dog_name: string | null
}

async function apiErrorMessage(res: Response): Promise<string> {
  const err = await res.json().catch(() => null) as { errors?: string[] } | null
  if (err?.errors?.length) return err.errors.join(", ")
  return res.statusText || "Request failed"
}

export async function getPortraitStatus(): Promise<PortraitStatusResponse> {
  const res = await fetch(`${API_BASE}/portrait/status`, { credentials: "include" })
  if (!res.ok) throw new Error(await apiErrorMessage(res))
  return res.json()
}

export async function regeneratePortrait(photo: File): Promise<void> {
  const form = new FormData()
  form.append("portrait_source_photo", photo)
  const res = await fetch(`${API_BASE}/portrait/regenerate`, {
    method: "POST",
    body: form,
    credentials: "include",
  })
  if (!res.ok) throw new Error(await apiErrorMessage(res))
}
